import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReusableBreadcrumbs from "../../CommonComponents/ReusableBreadCrumbs";
import Button from "../../Button";
import InputField from "../../CommonComponents/InputField";
import RichTextEditor from "../../CommonComponents/RichTextEditor";
import { getDataFromStorage } from "../../../util";
import constants, { RESULT_STATUS } from "../../../constants";
import ToggleButton from "../../CommonComponents/ToggleButton";
import QnCountField from "../Tests/QnCountField";
import InputDropdown from "../../CommonComponents/InputDropdown";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import AlertContext from "../../../context/AlertContext";
import Radio from "../../CommonComponents/Radio";
import DragAndDropUpload from "../../CommonComponents/DragAndDropUpload";
import SandPackEditor from "../../Student/AssignmentPage/SandPackEditor";
import SandpackReactEditor from "../../Student/AssignmentPage/SandpackReactEditor";
import { nanoid } from "nanoid";
import useS3FileManagement from "../../../Hooks/useS3FileManagement";
import Checkbox from "../../CommonComponents/Checkbox";
import { useParams, useSearchParams } from "react-router-dom";
import useAddOrUpdateLp from "../../../Hooks/useApiCall";
import EmbeddedLink from "./EmbeddedLink";
import Loading from "../../Notification-Loading/Loading/Loading";
import Toast from "../../CommonComponents/Toast";

const validator = {
  name: (value) => (!value || value.trim() === "" ? "Name is required" : null),
  time: (value) => (!value || value <= 0 ? "Invalid Time" : null),
  marks: (value) => (!value || value <= 0 ? "Invalid mark" : null),
  template: (value) => (!value ? "Template is not selected" : null),
  topicData: (value) => (!value ? "At least one topic must be selected" : null),
};

const AssignmentForm = (Props) => {
  const companyId = getDataFromStorage("companyId");

  const isGradiousUniversity =
    parseInt(companyId) === constants.GRADIOUS_ACCOUNT_ID;
  const useCommonFunctionHks = useCommonFunctionHooks();
  const axios = useAxiosPrivate();
  const {
    setOpenSandpackEditor,
    setPreview,
    setIsLoaded,
    setShowNotify,
    openSandpackEditor,
    setLpData2,
    lpData2,
    handleNavigateToLpAfterAddTest,
    setFromList,
    navigate,
    sandpackFiles,
    fromList,
    isOldLpDetail,
  } = useContext(AlertContext);
  const {
    onMultiPartUpload,
    getPreSignedUrl: getSignedUrl,
    uploadWithPresign,
  } = useS3FileManagement();
  const { libid } = useParams();
  const [searchParms] = useSearchParams();

  const selectable = searchParms.get("selectable") === "true";
  const lpid = searchParms.get("lpId") || null;
  const moduleId = searchParms.get("moduleId") || null;
  const chapterId = searchParms.get("chapterId") || null;
  const batchId = searchParms.get("bId") || null;

  let queryString = `${
    selectable
      ? `?selectable=${selectable}${lpid ? `&lpId=${lpid}` : ""}${
          moduleId ? `&moduleId=${moduleId}` : ""
        }${chapterId ? `&chapterId=${chapterId}` : ""}${
          batchId ? `&bId=${batchId}` : ""
        }`
      : ""
  }`;
  const baseRoute = batchId ? `/batches/${batchId}/courses` : "/learningpath";
  const isEdit = Number.isInteger(+libid);

  const [showSandpackOptions, setShowSandpackOptions] = useState(false);
  const { handleAddOrUpdateLp } = useAddOrUpdateLp();
  const { type, questionid } = useParams();

  const breadcrumbItems = [
    { label: "Library" },
    {
      label: `Assignment`,
      href: lpid
        ? `/library/${type}/testlist${queryString}`
        : `/library/${type}/questionlist`,
      onClick: () => setOpenSandpackEditor(false),
    },
    { label: `${questionid ? "Edit" : "Add"} Assignment` },
  ];

  const [questionDetail, setQuestionDetail] = useState({
    name: "",
    marks: "",
    maxTime: "",
    description: "",
    sandpack: 0,
    template: {},
    topic: "",
    questionType: "",
    autoEvaluate: 0,
    link: [], // file upload
    links: [], //embedded link
  });
  const [attachments, setAttachments] = useState([]);
  const [filesFromLib, setFilesFromLib] = useState([]);
  const [topics, setTopics] = useState([]);
  const [errors, setErrors] = useState({});
  const [dataIsLoading, setDataIsLoading] = useState(false);
  // const navigate = useNavigate();

  const [toastType, setToastType] = useState("warning");
  const [openToast, setOpenToast] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    fetchQuestionTopic();
  }, [axios]);

  console.log("Props:", Props);

  // useEffect(() => {
  //   if (props.isqueReport) {
  //     setSeletedTemplate(
  //       !props.selectque.hasOwnProperty("template") ||
  //         props.selectque.template === null
  //         ? { id: "", value: "" }
  //         : props.selectque.template,
  //     );

  //     setShowSandpackOptions(
  //       !props.selectque.hasOwnProperty("template") ||
  //         props.selectque.template === null
  //         ? false
  //         : true,
  //     );

  //     setEmbedLinksList(
  //       props.selectque.embedLinks ? props.selectque.embedLinks : [],
  //     );
  //   } else return;
  // }, [
  //   props.selectque,
  //   props.isqueReport,
  //   setSeletedTemplate,
  //   openSandpackEditor,
  //   setShowSandpackOptions,
  // ]);

  // useEffect(() => {
  //   if (props.isqueReport) {
  //     let links =
  //         props.selectque?.link !== null && props.selectque?.link?.length > 0
  //           ? [...props.selectque.link]
  //           : [],
  //       fileDetails = [];
  //     for (let link = 0; link < links.length; link++) {
  //       fileDetails.push({
  //         file: {
  //           name: links[link].link.substring(
  //             links[link].link.lastIndexOf("/") + 1,
  //             links[link].link.length,
  //           ),
  //         },
  //         checked: links[link].checked,
  //         url: `${process.env.REACT_APP_NODE_API}${links[link].link}`,
  //         link: links[link].link,
  //       });
  //     }
  //     setFilesFromLib(fileDetails);
  //   } else return;
  // }, [props.isqueReport, props.selectque]);

  useEffect(() => {
    const getTopics = async () => {
      setIsLoaded(true);
      try {
        let response = await axios.get(
          `node/admin/topic/get/${0}`,
          useCommonFunctionHks.getHeaderDetailsForAxios(),
        );

        setTopics(
          response.data.map((topic) => {
            return {
              value: topic.id,
              label: topic.name,
            };
          }),
        );
      } catch (error) {
        useCommonFunctionHks.getCatchBlockDetails(error);
      }
    };

    const getQuestionDetails = async () => {
      try {
        setDataIsLoading(true);
        if (getDataFromStorage("role") === constants.Roles.tutor)
          setPreview(true);
        // Determine the endpoint based on the `id` value

        const endpoint = `node/admin/content/${questionid}`;

        console.log("endPoint:", endpoint);

        const response = await axios.get(
          endpoint,
          useCommonFunctionHks.getHeaderDetailsForAxios(),
        );

        let json = response.data;
        let newData;

        newData = json.data;

        newData.qnId = questionid;
        newData.published = 0;

        console.log("newData:", newData);

        let links = newData.link;
        let fileDetails = [];
        for (let link = 0; link < links.length; link++) {
          fileDetails.push({
            file: {
              name: links[link].link.substring(
                links[link].link.lastIndexOf("/") + 1,
                links[link].link.length,
              ),
            },
            isDownloadable: links[link].checked,
            url: `${process.env.REACT_APP_NODE_API}${links[link].link}`,
            link: links[link].link,
            id: nanoid(),
          });
        }
        setFilesFromLib(fileDetails);
        setQuestionDetail((prev) => {
          return {
            ...prev,
            name: newData?.name,
            id: newData?.id,
            autoEvaluate: newData.autoEvaluate,
            maxTime: newData.timelimit / 60,
            marks: newData.marks,
            description: newData?.description,
            topic: newData.topicid,
            links: newData.embedLinks ?? [],
            link: fileDetails ?? [],
            template: newData.template ?? {},
            sandpack: newData.hasOwnProperty("template") ? 1 : 0,
          };
        });
      } catch (error) {
        useCommonFunctionHks.getCatchBlockDetails(error);
        // setQueLoading(true);
      } finally {
        setDataIsLoading(false);
      }
    };
    questionid && getQuestionDetails();
  }, [questionid]);

  const fetchQuestionTopic = async () => {
    try {
      const {data} = await axios.get(
        `node/admin/topic/get/${0}`,
        useCommonFunctionHks.getHeaderDetailsForAxios(),
      );
      if(data.resultCode === RESULT_STATUS.SUCCESS){
        let topicsFormat = data?.data.map((top) => {
          return {
            value: top.id,
            label: top.name,
          };
        });
        setTopics(topicsFormat);
      }
    } catch (error) {
      const isUnAuth = error.message.includes("403");
      setShowNotify({
        show: true,
        msg: isUnAuth
          ? "Encountered an error while fetching coding challenge sections"
          : "You have been logged-out due to inactivity. Login again.",
        title: isUnAuth ? "Warning" : "Error",
        isUnAuth,
      });
      useCommonFunctionHks.getCatchBlockDetails(error);
    }
  };

  const onChangeQuestionDetail = (field, value, id) => {
    const error = validator[field] ? validator[field](value) : null;
    if (field === "template") {
      setQuestionDetail((prev) => ({
        ...prev,
        [field]: {
          id: id,
          value: value,
        },
      }));
      setErrors((prev) => ({
        ...prev,
        [field]: error,
      }));
    } else {
      setQuestionDetail((prev) => ({
        ...prev,
        [field]: value,
      }));
      setErrors((prev) => ({
        ...prev,
        [field]: error,
      }));
    }
  };

  const handleOpenEditor = (event) => {
    event.preventDefault();
    console.log("click");

    if (
      questionDetail.template.id === "" ||
      questionDetail.template.id === null
    ) {
      setShowNotify({
        show: true,
        title: "Warning",
        msg: "Please select the template",
      });
    } else setOpenSandpackEditor(true);
    console.log("setting Sandpack");
  };

  const supportedFormat = ["jpg", "jpeg", "png", "pdf"];

  const uploadFiles = (files = [], event) => {
    const isUploadableFormat = files.every((file) =>
      supportedFormat.includes(file.type.split("/")[1]),
    );
    if (!isUploadableFormat) {
      setShowNotify({
        show: true,
        title: "Warning",
        msg: "Please upload the supported file",
      });
      return;
    }
    let commentedDate = String(new Date());
    let newAttachment = [...attachments];
    let files1 = Array.from(event.target.files);

    console.log("files1:", files1);

    for (let i = 0; i < files1.length; i++) {
      let attachment = {
        id: nanoid(),
        file: files1[i],
        date: commentedDate,
        isDownloadable: false,
      };
      newAttachment.push(attachment);
    }
    console.log("newAttachment:", newAttachment);
    setAttachments(newAttachment);
    setQuestionDetail((prev) => ({
      ...prev,
      link: [...filesFromLib, ...newAttachment],
    }));
  };
  const onUpload = (event) => {
    const files = Array.from(event.target.files);
    console.log("files:", files);

    uploadFiles(files, event);
    event.target.value = "";
  };
  const handleDeleteAttachments = (attachmentId) => {
    setQuestionDetail((prev) => ({
      ...prev,
      link: prev.link.filter((attachment) => attachment.id !== attachmentId),
    }));
    setFilesFromLib((prev) =>
      prev.filter((attachment) => attachment.id !== attachmentId),
    );
    setAttachments((prevAttachment) =>
      prevAttachment.filter((attachment) => attachment.id !== attachmentId),
    );
  };

  const addLink = (value) => {
    setQuestionDetail((prev) => ({
      ...prev,
      ["links"]: prev.links.concat(value),
    }));
  };

  const deleteLink = (indexToDelete) => {
    setQuestionDetail((prev) => ({
      ...prev,
      links: prev.links.filter((_, index) => index !== indexToDelete),
    }));
  };
  const handleBackBtn = () => {
    let isUpdateState = true;

    if (lpid) {
      navigate(`${baseRoute}/${lpid}/module/${moduleId}`);
      return;
    } else {
      navigate(`/library/${constants.libTypeIds.ASSIGNMENT}/questionlist`);
      isUpdateState = false;
    }

    // if (isUpdateState) {
    //   props.setselectque([]);
    //   setIsFromLp(false);
    //   props.setisqueReport(false);
    //   setFromList({ isFromList: false, libType: "" });
    // }
  };

  const validateImageExtension = (file) => {
    let allowedExtensions = ["jpg", "jpeg", "png", "pdf", "gif"];
    let extension = file.name.split(".").pop().toLowerCase();

    return allowedExtensions.indexOf(extension) !== -1;
  };

  const handleSubmit = async (event, from) => {
    event.preventDefault();
    console.log("from", from);

    let fileNames = [],
      form = new FormData(),
      fileDownloadDetails = [],
      payloadData = { ...questionDetail },
      qnData = { result: "", success: true };

    if (questionid && from === "new") {
      delete payloadData.id;
    }

    console.log("payloadData:", payloadData);

    const nameError = validator.name(questionDetail.name);
    const timeError = validator.time(questionDetail?.maxTime);
    const markError = validator.marks(questionDetail?.marks);
    const templateError = questionDetail?.sandpack
      ? validator.template(questionDetail.template?.value)
      : null;
    const topicError = validator.topicData(questionDetail.topic);

    const allErrors = {
      name: nameError,
      maxTime: timeError,
      marks: markError,
      template: templateError,
      topic: topicError,
    };
    setErrors(allErrors);

    const hasErrors = Object.values(allErrors).some((error) => error !== null);
    if (!hasErrors) {
      try {
        setDataIsLoading(true);

        if (typeof payloadData?.topic === "number") {
          qnData.topic = payloadData?.topic;
        } else {
          qnData.topicname = payloadData?.topic;
          delete payloadData.topic;
        }

        payloadData.maxTime = payloadData.maxTime * 60;
        qnData = { ...qnData, ...payloadData, maxtime: payloadData.maxTime };

        if (questionDetail.sandpack) {
          qnData.template = questionDetail.template;
        } else {
          qnData.template = {
            id: null,
            value: null,
          };
        }

        form.append("libtypename", "assignment");
        form.append("autoEvaluate", payloadData.autoEvaluate);
        form.append("qdata", JSON.stringify({ qdata: qnData }));
        form.append("libtypeid", constants.libTypeIds.ASSIGNMENT);

        if (questionDetail?.links.length > 0)
          form.append("embedLinks", questionDetail?.links);
        if (attachments.length > 0) {
          form.append("hasfiles", "yes");

          for (let file = 0; file < attachments.length; file++) {
            fileNames.push(attachments[file].file.name);
            fileDownloadDetails.push({
              [attachments[file].file.name]: attachments[file].isDownloadable,
            });

            let filePath = "library/misc/" + attachments[file].file.name;

            if (process.env.REACT_APP_DEPLOYMENT === "AWS") {
              const response = await onMultiPartUpload(
                filePath,
                attachments[file].file,
              );
              console.log("response", response);
            } else
              form.append(attachments[file].file.name, attachments[file].file);
          }
        }

        if (filesFromLib.length > 0) {
          console.log("edit scenario links is htere,", filesFromLib);

          form.append("links", JSON.stringify(filesFromLib));
        }

        form.append("fileNames", JSON.stringify(fileNames));
        form.append("isfiledownloadable", JSON.stringify(fileDownloadDetails));

        console.log("forms:", form);

        const res = await axios({
          data: form,
          method: "post",
          url: "node/admin/library/add",
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (questionDetail.sandpack) {
          if (questionDetail.template.value.toLowerCase() !== "react") {
            let files = JSON.parse(JSON.stringify(sandpackFiles));

            files["/index.js"] = {
              code: `//Don't remove the below code
// If you remove, console won't show up.
console.log = function(message) { 
  parent.postMessage({'message':message},"*");
}
console.error = console.debug = console.info = console.log;`,
            };

            for (let file in files) {
              let extraParams = {};
              let code = files[file]?.code;

              if (validateImageExtension({ name: file })) {
                extraParams.ContentEncoding = "base64";

                let base64Data = code
                  .replace(/^data:application\/octet-stream;base64,/, "")
                  .replace(/^data:image\/jpeg;base64,/, "")
                  .replace(/^data:image\/jpg;base64,/, "")
                  .replace(/^data:image\/png;base64,/, "");

                code = Uint8Array.from(atob(base64Data), (char) =>
                  char.charCodeAt(0),
                );
              }
              const key = `${process.env.REACT_APP_WEBSITE_HOST}/library/${res.data.data.libid}${file}`,
                fileType = files[file]?.code.slice(
                  files[file]?.code.lastIndexOf(".") + 1,
                );

              const preSignedData = await getSignedUrl(
                key,
                constants.S3_UPLOAD_TYPE.HOST,
                fileType,
                "PUT",
              );
              console.log("preSigned", preSignedData);

              // fetch()
              await uploadWithPresign(
                preSignedData.url,
                undefined,
                code,
                fileType,
                constants.S3_UPLOAD_TYPE.HOST,
              );
            }
          } else if (questionDetail.template.value.toLowerCase() === "react") {
            const key = `${process.env.REACT_APP_WEBSITE_HOST}/library/${res.data.data.libid}/${res.data.data.libid}.json`;
            const preSignedData = await getSignedUrl(
              key,
              constants.S3_UPLOAD_TYPE.HOST,
              "json",
              "PUT",
            );
            console.log("preSigned", preSignedData);

            await uploadWithPresign(
              preSignedData.url,
              undefined,
              JSON.stringify(sandpackFiles),
              "json",
              constants.S3_UPLOAD_TYPE.HOST,
            );
          }
        }

        if (res.data?.resultCode === constants.RESULT_STATUS.SUCCESS) {
          if (from === "new" && lpid) {
            let tests = [res.data.data.libid];
            const { data } = await axios.post(
              `node/admin/learningpath/${lpid}/module/${moduleId}/assign-tests`,
              { type: constants.libTypeIds.ASSIGNMENT, tests, chapterId },
            );

            if (data.resultCode === constants.RESULT_STATUS.SUCCESS) {
              navigate(
                `${baseRoute}/${lpid}/module/${moduleId}${
                  chapterId ? `?chapterId=${chapterId}` : ""
                }`,
              );
            } else {
              navigate(
                `/library/${constants.libTypeIds.ASSIGNMENT}/testlist${queryString}`,
              );
              throw new Error(
                `The assignment is created but unable to add to path`,
              );
            }
          } else {
            setShowNotify({
              show: true,
              title: "Success",
              msg: res.data.message,
              primaryButtonFunction: () => {
                useCommonFunctionHks.handleClose();
                navigate(
                  lpid
                    ? `${baseRoute}/${lpid}/module/${moduleId}${
                        chapterId ? `?chapterId=${chapterId}` : ""
                      }`
                    : `/library/${constants.libTypeIds.ASSIGNMENT}/questionlist`,
                );
              },
            });
          }
        } else {
          setShowNotify({
            show: true,
            title: "Error",
            msg: "Something went wrong. Please try again later.",
          });
        }
      } catch (error) {
        console.error("error", error);

        useCommonFunctionHks.getCatchBlockDetails(error);
      } finally {
        setDataIsLoading(false);
      }
    } else {
      setOpenToast(true);
      setErrMsg("Please fill the highlighted fields.");
    }
  };

  const openFile = async (file) => {
    console.log("file:", file);
    if (file.hasOwnProperty("url")) {
      const preSignedData = await getSignedUrl(
        file.link,
        undefined,
        file.link.split(".").pop(),
        "GET",
      );
      console.log("presignedData:", preSignedData);
      window.open(preSignedData.url, "_blank");
    } else {
      const fileURL = URL.createObjectURL(file.file);
      window.open(fileURL, "_blank");
    }
  };

  console.log("questionDetails:", questionDetail);
  console.log("error:", errors);

  return (
    <div className="assignment-question-entry-main-container">
      {dataIsLoading && <Loading />}
      <Toast
        open={openToast}
        onClose={() => setOpenToast(false)}
        message={errMsg}
        type={toastType}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        // slots={{ transition: Slide }}
      />
      {openSandpackEditor ? (
        questionDetail.template.value?.toLowerCase() === "react" ? (
          <SandpackReactEditor
            learnerId
            libDetails={questionDetail}
            isqueReport={questionid ? true : false}
            selectedTemplate={questionDetail.template}
            openSandpackEditor={openSandpackEditor}
            setOpenSandpackEditor={setOpenSandpackEditor}
          />
        ) : (
          <SandPackEditor
            learnerId
            libDetails={questionDetail}
            isqueReport={questionid ? true : false}
            selectedTemplate={questionDetail.template}
            openSandpackEditor={openSandpackEditor}
            setOpenSandpackEditor={setOpenSandpackEditor}
          />
        )
      ) : (
        <>
          <ReusableBreadcrumbs items={breadcrumbItems} />
          <section className="assignment-question-entry-header-container">
            <div>{questionid ? "Update " : "Add "}Assignment</div>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              {(getDataFromStorage("role") === constants.Roles.admin ||
                getDataFromStorage("role") === constants.Roles.creator ||
                getDataFromStorage("role") === constants.Roles.super_admin ||
                getDataFromStorage("role") === constants.Roles.trainer) &&
                questionid && (
                  <Button
                    size="sm"
                    hierarchy={{
                      type: "primary",
                      buttonText: "Update",
                    }}
                    onClick={(e) => handleSubmit(e, "update")}
                    disable={dataIsLoading}
                  />
                )}
              {!questionid && (<Button
                size="sm"
                hierarchy={{
                  type: "primary",
                  buttonText:"Save",
                }}
                onClick={(e) => handleSubmit(e, "new")}
                disable={dataIsLoading}
              />)}
            </div>
          </section>
          <section className="assignment-question-entry-content-container">
            <div className="assignment-question-entry-content-section-1">
              <InputField
                label="Name"
                name="name"
                placeholder="Enter the assignment name"
                value={questionDetail.name}
                onChange={(event) =>
                  onChangeQuestionDetail("name", event.target.value)
                }
                hintText={errors.name}
                destructive={!!errors.name}
              />
            </div>

            <div className="assignment-question-entry-content-section-2">
              <RichTextEditor
                title="Instruction"
                name="description"
                value={questionDetail.description}
                onChange={(event) =>
                  onChangeQuestionDetail("description", event)
                }
              />
            </div>

            <div className="assignment-question-entry-content-section-3">
              {isGradiousUniversity && (
                <ToggleButton
                  text="Autoevaluate :"
                  name="autoEvaluate"
                  pressed={!!questionDetail?.autoEvaluate}
                  onChange={(checked) =>
                    onChangeQuestionDetail("autoEvaluate", checked ? 1 : 0)
                  }
                  reverse
                />
              )}
            </div>

            <div className="assignment-question-entry-content-section-4">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  alignItems: "center",
                }}
              >
                <p className="question-config-title">
                  Maximum Time allowed (hrs)
                </p>
                <QnCountField
                  className="question-config"
                  id="question-config"
                  name="maxTime"
                  value={questionDetail?.maxTime}
                  onChange={(event) => {
                    onChangeQuestionDetail(
                      event.target.name,
                      event.target.value,
                    );
                  }}
                  onClick={(value) => onChangeQuestionDetail("maxTime", value)}
                  hintText={errors.maxTime}
                  destructive={errors.maxTime}
                />
                {/* <p className="config-duration-hint-text">{errors.duration}</p> */}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  alignItems: "center",
                }}
              >
                <p className="question-config-title">Marks</p>
                <QnCountField
                  className="question-config"
                  id="question-config"
                  name="marks"
                  value={questionDetail.marks}
                  destructive={errors.marks}
                  onChange={(event) =>
                    onChangeQuestionDetail(
                      event.target.name,
                      event.target.value,
                    )
                  }
                  onClick={(value) => onChangeQuestionDetail("marks", value)}
                />
                <p className="config-mark-hint-text">{errors.marks}</p>
              </div>
            </div>
            <div className="assignment-question-entry-content-section-6">
              <InputDropdown
                label="Topic"
                placeholder="Select topic"
                options={topics}
                creatable
                hintText={errors?.topic}
                destructive={!!errors?.topic}
                value={questionDetail.topic}
                name="topic"
                onChange={(value) => {
                  onChangeQuestionDetail("topic", value);
                }}
              />
            </div>

            <div className="assignment-question-entry-content-section-code-template">
              <p>Assignment Submission through Sandpack:</p>
              <div className="assignment-question-entry-content-section-code-template-main-container">
                <ToggleButton
                  text={questionDetail.sandpack ? "Enabled" : "Disabled"}
                  name="enable"
                  pressed={!!questionDetail?.sandpack}
                  onChange={(checked) =>
                    onChangeQuestionDetail("sandpack", checked ? 1 : 0)
                  }
                />
                <p>Choose a Sandpack Template:</p>
                <div className="assignment-question-entry-content-section-code-template-content-wrapper-options">
                  <Radio
                    text="Vanilla"
                    size="sm"
                    checked={questionDetail.template.id === 1}
                    onChange={(checked) =>
                      onChangeQuestionDetail("template", "Vanilla", 1)
                    }
                    disabled={!questionDetail?.sandpack}
                  />
                  <Radio
                    text="Static"
                    size="sm"
                    checked={questionDetail.template.id === 2}
                    onChange={(checked) =>
                      onChangeQuestionDetail("template", "Static", 2)
                    }
                    disabled={!questionDetail?.sandpack}
                  />
                  <Radio
                    text="React JS"
                    size="sm"
                    checked={questionDetail.template.id === 3}
                    onChange={(checked) =>
                      onChangeQuestionDetail("template", "React", 3)
                    }
                    disabled={!questionDetail?.sandpack}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <Button
                    size="sm"
                    hierarchy={{
                      type: "linkGrey",
                      buttonText: "Code Editor",
                    }}
                    icon={{
                      icon: (
                        <svg
                          width="7"
                          height="12"
                          viewBox="0 0 7 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.835938 10.835L5.83594 5.83502L0.835938 0.835022"
                            stroke="#D0D5DD"
                            stroke-width="1.67"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      ),
                      type: "trailing",
                    }}
                    onClick={(e) => handleOpenEditor(e)}
                    disable={
                      !questionDetail?.sandpack ||
                      !questionDetail.template.hasOwnProperty("id")
                    }
                  />
                </div>
              </div>
              <p className="config-code-template-hint-text">
                {errors.template}
              </p>
            </div>

            <div className="assignment-question-entry-content-section-5">
              <p>Add your Attachment</p>
              <DragAndDropUpload
                onUpload={onUpload}
                file={questionDetail.link}
                isMultiUpload={false}
                text="Drop your attachment"
                uploadedFile={
                  <UploadFile
                    attachments={questionDetail.link}
                    handleDeleteAttachments={handleDeleteAttachments}
                    onUpload={onUpload}
                    supportFormat="jpg, png,pdf,jpeg"
                  />
                }
              />
              <div className="assignment-question-entry-content-section-5-upload-files-container">
                {questionDetail.link.length >= 1 &&
                  questionDetail.link.map((file) => (
                    <div
                      className="assignment-question-entry-content-section-5-upload-files-content-container"
                      onClick={() => openFile(file)}
                    >
                      <div className="assignment-question-entry-content-section-5-upload-file-detail">
                        <div className="assignment-question-entry-content-section-5-upload-file-detail-name">
                          <svg
                            width="18"
                            height="22"
                            viewBox="0 0 18 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V8M10 1L17 8M10 1V8H17"
                              stroke="#344054"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <p>
                            {file?.file?.name ?? file.link.split("/").pop()}
                          </p>
                        </div>
                        <svg
                          width="13"
                          height="15"
                          viewBox="0 0 13 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={() => handleDeleteAttachments(file.id)}
                        >
                          <path
                            d="M0.5 3.16667H1.83333M1.83333 3.16667H12.5M1.83333 3.16667V12.5C1.83333 12.8536 1.97381 13.1928 2.22386 13.4428C2.47391 13.6929 2.81304 13.8333 3.16667 13.8333H9.83333C10.187 13.8333 10.5261 13.6929 10.7761 13.4428C11.0262 13.1928 11.1667 12.8536 11.1667 12.5V3.16667H1.83333ZM3.83333 3.16667V1.83333C3.83333 1.47971 3.97381 1.14057 4.22386 0.890524C4.47391 0.640476 4.81304 0.5 5.16667 0.5H7.83333C8.18696 0.5 8.52609 0.640476 8.77614 0.890524C9.02619 1.14057 9.16667 1.47971 9.16667 1.83333V3.16667M5.16667 6.5V10.5M7.83333 6.5V10.5"
                            stroke="#F04438"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <Checkbox
                        supportingText="Attachment Downloadable"
                        checked={file.isDownloadable}
                        onChange={(value) => {
                          setQuestionDetail((prev) => ({
                            ...prev,
                            link: prev.link.map((t) =>
                              t.id === file.id
                                ? { ...t, isDownloadable: value }
                                : t,
                            ),
                          }));
                          setFilesFromLib((prev) =>
                            prev.map((tc) =>
                              tc.id === file.id
                                ? { ...tc, isDownloadable: value }
                                : tc,
                            ),
                          );
                          setAttachments((prev) =>
                            prev.map((tc) =>
                              tc.id === file.id
                                ? { ...tc, isDownloadable: value }
                                : tc,
                            ),
                          );
                        }}
                      />
                    </div>
                  ))}
              </div>
            </div>

            {/* <div className="e">
              <InputField
                label="Embedded Links"
                name="embeddedlinks"
                placeholder="Enter link"
                value={currentLink}
                onChange={(event) => setCurrentLink(event.target.value)}
                hintText={errors.name}
                destructive={!!errors.name}
              />
              <Button
                size="lg"
                hierarchy={{ type: "secondaryGrey", buttonText: "Link" }}
                destructive={false}
                icon={{
                  type: "leading",
                  icon: (
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.66927 0.834961V12.5016M0.835938 6.66829H12.5026"
                        stroke="#344054"
                        stroke-width="1.67"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  ),
                }}
                disable={currentLink.length <= 5}
                onClick={() => addLink()}
              />
            </div>
            {questionDetail.links.length >= 1 && (
              <>
                <p className="section-8-link-text">Added Links:</p>
                {questionDetail.links.map((link, index) => (
                  <div className="assignment-question-entry-content-section-8">
                    <div className="section-8-links">
                      <InputField
                        name="embeddedlinks"
                        placeholder="Enter link"
                        value={link}
                      />
                      <IconButton
                        size="md"
                        hierarchy="secondaryGrey"
                        destructive={true}
                        onClick={() => deleteLink(index)}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.5 4.99984H4.16667M4.16667 4.99984H17.5M4.16667 4.99984V16.6665C4.16667 17.1085 4.34226 17.5325 4.65482 17.845C4.96738 18.1576 5.39131 18.3332 5.83333 18.3332H14.1667C14.6087 18.3332 15.0326 18.1576 15.3452 17.845C15.6577 17.5325 15.8333 17.1085 15.8333 16.6665V4.99984H4.16667ZM6.66667 4.99984V3.33317C6.66667 2.89114 6.84226 2.46722 7.15482 2.15466C7.46738 1.8421 7.89131 1.6665 8.33333 1.6665H11.6667C12.1087 1.6665 12.5326 1.8421 12.8452 2.15466C13.1577 2.46722 13.3333 2.89114 13.3333 3.33317V4.99984M8.33333 9.1665V14.1665M11.6667 9.1665V14.1665"
                            stroke="#F04438"
                            stroke-width="1.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </IconButton>
                    </div>
                  </div>
                ))}
              </>
            )} */}
            <div className="assignment-question-entry-content-section-7">
              <EmbeddedLink
                links={questionDetail.links ?? []}
                onAdd={addLink}
                onDelete={deleteLink}
              />
            </div>
          </section>
        </>
      )}
    </div>
  );
};

const UploadFile = ({
  attachments,
  handleDeleteAttachments,
  onUpload,
  supportFormat,
}) => {
  return (
    <div className="assignment-attachment-container">
      <div className="dragAndDropUploadTopSec">
        <div className="dragAndDropUploadText">Drag & Drop your image</div>
        <div className="dragAndDropUploadSupFormat">
          Supported formats ({supportFormat})
        </div>
      </div>
      <div className="dragAndDropUploadOrText">or</div>
      <input
        type="file"
        multiple
        id="fileInput"
        onChange={onUpload}
        accept={supportFormat}
        className="dragAndDropUploadInput"
      />
      <div className="dragAndDropUploadBtn">
        <Button
          size="sm"
          hierarchy={{ type: "secondaryGrey", buttonText: "Upload file" }}
          icon={{
            icon: (
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 12.5V15.8333C18 16.2754 17.8244 16.6993 17.5118 17.0118C17.1993 17.3244 16.7754 17.5 16.3333 17.5H4.66667C4.22464 17.5 3.80072 17.3244 3.48816 17.0118C3.17559 16.6993 3 16.2754 3 15.8333V12.5M14.6667 6.66667L10.5 2.5M10.5 2.5L6.33333 6.66667M10.5 2.5V12.5"
                  stroke="#344054"
                  strokeWidth="1.67"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ),
            type: "leading",
          }}
        />
      </div>
    </div>
  );
};

export default AssignmentForm;
